<template>
  <a-modal
    title="审核通过"
    v-model="visible"
    :confirmLoading="loading"
    :destroyOnClose="true"
    @ok="save"
  >
    <a-form :form="form">
      <a-form-item label="平台额外补贴比例（仅可设置一次）">
        <a-input
          addonAfter="%"
          placeholder="请填写0-50的整数"
          v-decorator="[
            'num',
            {
              rules: [
                { required: true, message: '请输入补贴比例' },
                {
                  transform: val => +val,
                  type: 'integer',
                  message: '请输入整数'
                },
                {
                  validator: numCheck
                }
              ]
            }
          ]"
        ></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import Api from "@/api";
export default {
  name: "constractPass",
  data() {
    return {
      form: this.$form.createForm(this),
      id: "",
      loading: false,
      visible: false
    };
  },
  methods: {
    save() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true;
          try {
            let params = {
              contract_id: this.id,
              additional_allowance_ratio: values.num
            };
            await Api.hunter.acceptContract(params);
            this.close();
            this.$emit("ok");
          } catch (e) {}
          this.loading = false;
        }
      });
    },
    show(id) {
      this.visible = true;
      this.id = id;
    },
    close() {
      this.visible = false;
    },
    numCheck(rule, val, callback) {
      if (val > 50 || val < 0) {
        callback("请填写0-50的整数");
      }
      callback();
    }
  }
};
</script>

<style scoped lang="scss"></style>
